
// This file is auto-generated by generate-version.js
export const VERSION = {
  sha: 'd797fa228b494a1a6bb77d14de43cf2eaae89062',
  tag: null
};



// WEBPACK FOOTER //
// ./src/environments/version.ts